import React from 'react';
import { Box, Chip } from '@mui/material';

const LegendChips = () => (
    <Box
        sx={{
                mt: 4,
                // ✅ FIX: These properties make the chips wrap gracefully
                display: 'flex',       // Treat the children (Chips) as flex items
                flexWrap: 'wrap',      // Allow items to wrap to the next line
                gap: 1,                // Add a consistent gap between chips (replaces mr: 1)
        }}
    >
            {/*
            Note: The `mr: 1` (margin-right) on each chip has been removed
            in favor of the `gap: 1` on the parent Box. This creates more
            consistent spacing when items wrap.
        */}
            <Chip label="0–4 Low" sx={{ backgroundColor: '#285f54', color: '#fff' }} />
            <Chip label="5–9 Medium" sx={{ backgroundColor: '#1f7d6b', color: '#fff' }} />
            <Chip label="10–14 High" sx={{ backgroundColor: '#1aa27e', color: '#fff' }} />
            <Chip label="15–19 Very High" sx={{ backgroundColor: '#12c099', color: '#fff' }} />
            <Chip label="20+ Peak" sx={{ backgroundColor: '#29f0b5', color: '#000' }} />
    </Box>
);

export default LegendChips;
